module.exports = __webpack_public_path__ + "img/9788962621594.5f752d51.jpg";